const CASE_DATA_FORM_FIELD_NAMES = {
  'caseNumber': "Case number",
  'jobTitle': "Job title",
  'injuryDate': "Date of injury",
  'injuryPlace': "Where the event occurred",
  'incidentDescription': "Description of inury or illness",
  'mostSeriousOutcome': "Most serious outcome",
  'awayFromWork': "Days away from work",
  'jobTransferRestriction': "Days on job transfer or restriction",
  'dateOfBirth': "Date of birth",
  'employeeHiredDate': "Employee's date hired",
  'employeeGender': "Employee's gender",
  'emergencyRoom': "Was employee treated in an emergency room",
  'treatmentPatient': "Was employee hospitalized overnight",
  'timeEmployeeBegan': "Time employee began work",
  'timeOfEvent': "Time of event",
  'timeUknown': "Time cannot be determined",
  'beforeIncidentOccured': "What was the employee doing just before the incident occurred",
  'ilnessOrInjuryOccured': "What happened",
  'theInjuryOrIllness': "What was the injury or illness",
  'objectHarmEmployee': "What object or substance directly harmed the employee",
  'dateOfDeath': "Date of death",
};

export default CASE_DATA_FORM_FIELD_NAMES;



/** WEBPACK FOOTER **
 ** ./src/constants/caseDataFormFieldNames.js
 **/